import React from "react"
import {
  UserOutlined,
  ContactsOutlined,
  BarChartOutlined,
  QuestionCircleOutlined,
  CalendarOutlined,
  PropertySafetyOutlined
} from "@ant-design/icons"
import { pathToRegexp } from "path-to-regexp"
import { MenuItemType } from "@/components/PHMenu/MenuType"
export const menuList: Array<MenuItemType> = [
  {
    key: "0",
    keyPath: ["0"],
    title: "VACANCY",
    icon: <BarChartOutlined />,
    router: (customerId: string) => `/customers/${customerId}/vacancies`,
    routeExp: pathToRegexp(/^\/customers\/([^/]+?)\/vacancies/i),
    roles: ["user"]
  },
  {
    key: "4",
    keyPath: ["4"],
    title: "LIVE INTERVIEW",
    icon: <CalendarOutlined />,
    outerJump: (customerId?: string): void => {
      const domain = document.domain.replace("edge", "ac")
      customerId
        ? window.open(`${document.location.protocol}//${domain}/?currentCustomerId=${customerId}`)
        : window.open(`${document.location.protocol}//${domain}/`)
    },
    roles: ["admin", "assessor"]
  },
  {
    key: "1",
    keyPath: ["1"],
    title: "USERS",
    icon: <UserOutlined />,
    router: (customerId: string) => `/customers/${customerId}/users`,
    routeExp: pathToRegexp("/customers/:customerId/users"),
    roles: ["admin"]
  },
  {
    key: "2",
    keyPath: ["2"],
    title: "CUSTOMERS",
    icon: <ContactsOutlined />,
    router: (customerId: string) => `/customers/${customerId}/allCustomers`,
    routeExp: pathToRegexp(/^\/customers\/([^/]+?)\/allCustomers/i),
    roles: ["admin"]
  },
  {
    key: "3",
    keyPath: ["3"],
    title: "QUESTION BANK",
    icon: <QuestionCircleOutlined />,
    outerJump: (): void => {
      const domainName: {
        [key: string]: string
      } = {
        development: "qb.localhost.com:3344",
        qa: "question-bank.qa.predictivehire.com",
        demo: "question-bank.sandbox.predictivehire.com",
        production: "question-bank.product.predictivehire.com"
      }
      const env = process.env.REACT_APP_ENVIRONMENT
      const domain = domainName[env]
      window.open(`${document.location.protocol}//${domain}/`)
    },
    roles: ["admin"]
  },
  {
    key: "5",
    keyPath: ["5"],
    title: "MODELS",
    icon: <PropertySafetyOutlined />,
    router: (customerId: string) => `/customers/${customerId}/models`,
    routeExp: pathToRegexp(/^\/customers\/([^/]+?)\/models/i),
    roles: ["admin"]
  }
]
